import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from '@features/auth/guards/auth.guard';
import { SelectivePreloadStrategy } from '@core/routing/selective-preload.strategy';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'auth',
  },
  {
    path: 'auth',
    loadChildren: () => import('@features/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadChildren: () =>
      import('@features/dashboard/dashboard.module').then((m) => m.DashboardModule),
  },

  /*
   * Public, and deliberately a sibling of `dashboard` rather than a child: a
   * certificate is validated by whoever holds the code, so the screen sits
   * outside `authGuard` and outside the dashboard shell, which it would
   * otherwise inherit along with the sidebar and header it does not use.
   */
  {
    path: 'validate',
    loadChildren: () =>
      import('@features/vcr-validate/vcr-validate.module').then((m) => m.VCRValidateModule),
  },

  // ── Fallback ───────────────────────────────────────────────────────────────
  {
    path: '404',
    loadChildren: () =>
      import('@features/not-found/not-found.module').then((m) => m.NotFoundModule),
  },
  {
    path: '**',
    redirectTo: '404',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: SelectivePreloadStrategy,
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
